module.exports = __webpack_public_path__ + "img/content_bg6.cbf9adb.png";